export default {
  // Navbar
  'nav.home': 'Home',
  'nav.services': 'Servizi',
  'nav.portfolio': 'Portfolio',
  'nav.about': 'Chi Siamo',
  'nav.blog': 'Blog',
  'nav.contact': 'Contatti',
  'nav.getStarted': 'Inizia Ora',

  // Hero Section
  'hero.title': 'Servizi Fiscali e di Patronato Esperti',
  'hero.subtitle': 'Pianificazione fiscale strategica e gestione del patronato per privati e aziende con oltre 20 anni di eccellenza.',
  'hero.cta.primary': 'Prenota Consulenza',
  'hero.cta.secondary': 'I Nostri Servizi',
  'hero.badge.experience': '20+ Anni di Esperienza',
  'hero.badge.clients': '5.000+ Clienti Serviti',

  // Services Section
  'services.title': 'I Nostri Servizi',
  'services.subtitle': 'Soluzioni fiscali e di patronato complete su misura per le vostre esigenze',
  
  'services.individual.title': 'Consulenza Fiscale per Privati',
  'services.individual.desc': 'Assistenza fiscale personalizzata per privati con preparazione completa delle dichiarazioni dei redditi e ottimizzazione fiscale.',
  'services.individual.feature1': 'Dichiarazione dei redditi 730 e Redditi PF',
  'services.individual.feature2': 'Consulenza fiscale personalizzata',
  'services.individual.feature3': 'Detrazioni e deduzioni fiscali',

  'services.tax.title': 'Preparazione Fiscale',
  'services.tax.desc': 'Dichiarazioni fiscali complete per privati, aziende e dividendi di patronato con massima precisione e conformità.',
  'services.tax.feature1': 'Dichiarazioni individuali e aziendali',
  'services.tax.feature2': 'Dichiarazioni fiscali di patronato',
  'services.tax.feature3': 'Dichiarazioni fiscali statali e federali',

  'services.planning.title': 'Pianificazione Fiscale',
  'services.planning.desc': 'Strategie fiscali proattive durante tutto l\'anno per minimizzare le vostre passività e massimizzare i risparmi.',
  'services.planning.feature1': 'Strategie di riduzione fiscale',
  'services.planning.feature2': 'Pianificazione pensionistica',
  'services.planning.feature3': 'Pianificazione patrimoniale',

  'services.patronage.title': 'Servizi di Patronato',
  'services.patronage.desc': 'Servizi fiscali specializzati per cooperative e aziende di patronato, inclusi calcoli dei dividendi e conformità.',
  'services.patronage.feature1': 'Dichiarazioni fiscali cooperative',
  'services.patronage.feature2': 'Calcoli dividendi di patronato',
  'services.patronage.feature3': 'Consulenza sulla conformità',

  'services.irs.title': 'Assistenza Fiscale Specializzata',
  'services.irs.desc': 'Rappresentanza esperta in audit, appelli e risoluzione di controversie fiscali con le autorità competenti.',
  'services.irs.feature1': 'Difesa in caso di audit',
  'services.irs.feature2': 'Rappresentanza in appello',
  'services.irs.feature3': 'Risoluzione debiti fiscali',

  'services.business.title': 'Consulenza Aziendale',
  'services.business.desc': 'Servizi completi di contabilità, buste paga e consulenza finanziaria per far crescere la vostra attività.',
  'services.business.feature1': 'Contabilità e tenuta libri',
  'services.business.feature2': 'Elaborazione buste paga',
  'services.business.feature3': 'Consulenza finanziaria',

  'services.accounting.title': 'Servizi Contabili',
  'services.accounting.desc': 'Analisi finanziarie professionali, gestione del flusso di cassa e reportistica per decisioni aziendali informate.',
  'services.accounting.feature1': 'Rendiconti finanziari',
  'services.accounting.feature2': 'Gestione flusso di cassa',
  'services.accounting.feature3': 'Analisi di bilancio',

  'services.welfare.title': 'Servizi Previdenziali',
  'services.welfare.desc': 'Assistenza completa per tutte le pratiche previdenziali: dalla disoccupazione all\'invalidità, fino alla pensione.',
  'services.welfare.feature1': 'NASPI – Indennità di disoccupazione',
  'services.welfare.feature2': 'Pratiche di invalidità civile',
  'services.welfare.feature3': 'Richiesta e gestione pensioni',

  'services.caf.title': 'Servizi CAF',
  'services.caf.desc': 'Supporto per le pratiche CAF più importanti: successioni e registrazione contratti di locazione.',
  'services.caf.feature1': 'Dichiarazione di successione',
  'services.caf.feature2': 'Registrazione contratti di affitto',

  'services.immigration.title': 'Servizi Immigrazione',
  'services.immigration.desc': 'Assistenza qualificata per le pratiche di immigrazione: permessi di soggiorno e richiesta di cittadinanza italiana.',
  'services.immigration.feature1': 'Permessi di soggiorno',
  'services.immigration.feature2': 'Richiesta di cittadinanza',

  'services.cta': 'Scopri di Più',

  // Portfolio Section
  'portfolio.title': 'I Nostri Progetti',
  'portfolio.subtitle': 'Storie di successo e casi studio dei nostri clienti',
  'portfolio.filter.all': 'Tutti',
  'portfolio.filter.tax': 'Preparazione Fiscale',
  'portfolio.filter.business': 'Consulenza Aziendale',
  'portfolio.filter.patronage': 'Servizi di Patronato',
  'portfolio.cta': 'Visualizza Caso Studio',

  'portfolio.project1.title': 'Ottimizzazione Fiscale Aziendale',
  'portfolio.project1.desc': 'Riduzione del 35% delle passività fiscali per un\'azienda manifatturiera di medie dimensioni attraverso pianificazione strategica.',
  'portfolio.project1.category': 'Preparazione Fiscale',

  'portfolio.project2.title': 'Ristrutturazione Cooperativa',
  'portfolio.project2.desc': 'Ristrutturazione completa fiscale per una cooperativa agricola con 500+ membri e distribuzione dividendi di patronato.',
  'portfolio.project2.category': 'Servizi di Patronato',

  'portfolio.project3.title': 'Risoluzione Audit IRS',
  'portfolio.project3.desc': 'Rappresentanza di successo in un audit IRS complesso, con riduzione del 60% delle sanzioni proposte.',
  'portfolio.project3.category': 'Preparazione Fiscale',

  'portfolio.project4.title': 'Crescita Startup',
  'portfolio.project4.desc': 'Servizi completi di contabilità e consulenza fiscale per una startup tecnologica dalla fase iniziale alla crescita.',
  'portfolio.project4.category': 'Consulenza Aziendale',

  'portfolio.project5.title': 'Conformità Patronato',
  'portfolio.project5.desc': 'Implementazione di sistemi di conformità fiscale per una cooperativa di credito con $100M+ di attivi.',
  'portfolio.project5.category': 'Servizi di Patronato',

  'portfolio.project6.title': 'Pianificazione Patrimoniale',
  'portfolio.project6.desc': 'Strategia fiscale completa per la pianificazione patrimoniale e successione per un cliente con alto patrimonio netto.',
  'portfolio.project6.category': 'Consulenza Aziendale',

  // About Section
  'about.title': 'Chi Siamo',
  'about.subtitle': 'Oltre 20 anni di eccellenza nei servizi fiscali e di patronato',
  'about.description': 'Siamo un\'azienda leader nei servizi fiscali e di patronato, dedicata a fornire soluzioni finanziarie esperte a privati, aziende e cooperative. Il nostro team di professionisti certificati combina una profonda conoscenza fiscale con un servizio personalizzato.',
  
  'about.stat1.value': '5.000+',
  'about.stat1.label': 'Clienti Soddisfatti',
  'about.stat2.value': '$50M+',
  'about.stat2.label': 'Rimborsi Ottenuti',
  'about.stat3.value': '98%',
  'about.stat3.label': 'Tasso di Soddisfazione',
  'about.stat4.value': '20+',
  'about.stat4.label': 'Anni di Esperienza',

  'about.timeline.title': 'Il Nostro Percorso',
  'about.timeline.2005.title': 'Fondazione',
  'about.timeline.2005.desc': 'Avviata come piccola azienda di preparazione fiscale con focus sul servizio personalizzato.',
  'about.timeline.2010.title': 'Espansione Servizi',
  'about.timeline.2010.desc': 'Aggiunta di servizi di patronato e consulenza aziendale per soddisfare le esigenze dei clienti.',
  'about.timeline.2015.title': 'Certificazione IRS',
  'about.timeline.2015.desc': 'Ottenuta la certificazione IRS Enrolled Agent e ampliato il team con professionisti certificati.',
  'about.timeline.2020.title': 'Trasformazione Digitale',
  'about.timeline.2020.desc': 'Lancio di servizi online e consultazioni virtuali per una migliore accessibilità dei clienti.',
  'about.timeline.2025.title': 'Leader del Settore',
  'about.timeline.2025.desc': 'Riconosciuti come leader nei servizi fiscali e di patronato con oltre 5.000 clienti serviti.',

  // Blog Section
  'blog.title': 'Ultime Notizie e Approfondimenti',
  'blog.subtitle': 'Rimani aggiornato con consigli fiscali, notizie e strategie',
  'blog.readMore': 'Leggi di Più',
  'blog.category.tax': 'Consigli Fiscali',
  'blog.category.business': 'Business',
  'blog.category.patronage': 'Patronato',

  'blog.post1.title': 'Strategie di Pianificazione Fiscale 2025',
  'blog.post1.excerpt': 'Scopri le strategie chiave di pianificazione fiscale per massimizzare i tuoi risparmi nel 2025. Dalla pianificazione pensionistica alle detrazioni aziendali.',
  'blog.post1.date': '15 Gen 2025',

  'blog.post2.title': 'Comprendere i Dividendi di Patronato',
  'blog.post2.excerpt': 'Una guida completa su come funzionano i dividendi di patronato, le loro implicazioni fiscali e i requisiti di conformità per le cooperative.',
  'blog.post2.date': '10 Gen 2025',

  'blog.post3.title': 'Detrazioni Fiscali per Piccole Imprese',
  'blog.post3.excerpt': 'Massimizza le detrazioni fiscali della tua piccola impresa con la nostra guida esperta sulle spese deducibili e strategie di risparmio fiscale.',
  'blog.post3.date': '5 Gen 2025',

  // Contact Section
  'contact.title': 'Contattaci',
  'contact.subtitle': 'Prenota una consulenza o contattaci per qualsiasi domanda',
  
  'contact.info.title': 'Informazioni di Contatto',
  'contact.info.address': 'Via XXVI Aprile - Chiari (BS)',
  'contact.info.phone': 'Tel: 030 712 316',
  'contact.info.mobile': 'Mobile: 375 693 5807',
  'contact.info.email': 'stefania.navoni@enasc.eu',
  'contact.info.hours': 'Lun-Ven: 9:00-12:00, 15:00-19:00',
  'contact.info.saturday': 'Sabato: 9:00-12:00',
  'contact.info.taxSeason': 'Orario Esteso Durante la Stagione Fiscale',

  'contact.form.name': 'Nome Completo',
  'contact.form.email': 'Email',
  'contact.form.phone': 'Telefono',
  'contact.form.service': 'Servizio',
  'contact.form.service.placeholder': 'Seleziona un servizio',
  'contact.form.service.tax': 'Preparazione Fiscale',
  'contact.form.service.planning': 'Pianificazione Fiscale',
  'contact.form.service.patronage': 'Servizi di Patronato',
  'contact.form.service.irs': 'Rappresentanza IRS',
  'contact.form.service.business': 'Consulenza Aziendale',
  'contact.form.service.accounting': 'Servizi Contabili',
  'contact.form.message': 'Messaggio',
  'contact.form.submit': 'Invia Messaggio',

  // Footer
  'footer.description': 'Servizi fiscali e di patronato esperti per privati, aziende e cooperative. Certificati IRS con oltre 20 anni di eccellenza.',
  'footer.quickLinks': 'Link Rapidi',
  'footer.services.title': 'Servizi',
  'footer.services.tax': 'Preparazione Fiscale',
  'footer.services.planning': 'Pianificazione Fiscale',
  'footer.services.patronage': 'Servizi di Patronato',
  'footer.services.irs': 'Rappresentanza IRS',
  'footer.services.business': 'Consulenza Aziendale',
  'footer.services.accounting': 'Servizi Contabili',
  
  'footer.newsletter.title': 'Newsletter',
  'footer.newsletter.description': 'Iscriviti alla nostra newsletter per consigli fiscali e aggiornamenti.',
  'footer.newsletter.placeholder': 'La tua email',
  'footer.newsletter.button': 'Iscriviti',
  
  'footer.copyright': '© 2025 Servizi Fiscali e Patronato. Tutti i diritti riservati.',
  'footer.poweredBy': 'Realizzato con',

  // Not Found Page
  'notFound.title': '404 - Pagina Non Trovata',
  'notFound.description': 'La pagina che stai cercando non esiste.',
  'notFound.button': 'Torna alla Home',
};